import * as React from 'react';
import { selectionReportTranslations } from '../constants';
import { STATE } from 'app/constants';
import { api } from './api';
import { FrequencyReportView } from 'app/area/reports/frequency/frequency-report-view';
import { useTranslation } from 'app/infrastructure/translate/hooks';
import { 
  useContainerComponents, 
  useSelectors,
  useWorkingDefinitionFavouriteId
} from 'app/area/reports/hooks';
import { 
  useShouldInitiallyOpenPanel
} from 'app/area/reports/frequency/hooks';
import { useWorkingDefinitionTargetApplication } from 'app/area/reports/containers/target/hooks';
import { useWorkingDefinitionAggregationState } from 'app/area/reports/containers/aggregation/hooks';
import { useWorkingDefinitionExposureState } from 'app/area/reports/containers/distribution/hooks';
import { useWorkingDefinitionSelectedGroupByFields } from 'app/area/reports/containers/group-by/hooks';
import { useInstanceOptions } from 'app/area/favourite/favourite-context';
import { StatisticalReportExternalProps } from 'app/area/reports/types';

export function FrequencyReportContainer({
  drillDown, requestCustomWidth, reflowHandle
}: StatisticalReportExternalProps) {

  const {
    hideVisualizationOptions
  } = useInstanceOptions();

  const favouriteId = useWorkingDefinitionFavouriteId();
  
  const translation = useTranslation(STATE.selectionReport, selectionReportTranslations);

  const initiallyOpen = useShouldInitiallyOpenPanel();

  const {
    selectedAggregationField,
    selectedAggregationFunction,
    selectedUomSet
  } = useWorkingDefinitionAggregationState();

  const {
    selectedExposureApplication,
    selectedExposureFactor,
    selectedExposurePercent
  } = useWorkingDefinitionExposureState();

  const selectedTargetApplication = useWorkingDefinitionTargetApplication();

  const selectedGroupByFields = useWorkingDefinitionSelectedGroupByFields();

  const disabledTarget = !selectedAggregationField;

  const {
    aggregateFieldState,
    groupByFieldState,
    targetFieldState,
    distributionFieldState,
    chartState
  } = useSelectors();
  
  const {
    AggregationContainer,
    GroupByContainer,
    TargetContainer,
    ChartContainer,
    DistributionContainer
  } = useContainerComponents(api);

  if (!aggregateFieldState || !groupByFieldState || !targetFieldState || !distributionFieldState || !chartState) {
    return null;
  }

  return <FrequencyReportView
    translation={translation}
    disabledTarget={disabledTarget}
    aggregateFieldState={aggregateFieldState}
    groupByFieldState={groupByFieldState}
    targetFieldState={targetFieldState}
    distributionFieldState={distributionFieldState}
    chartState={chartState}
    initiallyOpen={initiallyOpen}
    AggregationContainer={AggregationContainer}
    GroupByContainer={GroupByContainer}
    TargetContainer={TargetContainer}
    ChartContainer={ChartContainer}
    DistributionContainer={DistributionContainer}
    favouriteId={favouriteId}
    hideVisualizationOptions={hideVisualizationOptions}
    selectedAggregationField={selectedAggregationField}
    selectedAggregationFunction={selectedAggregationFunction}
    selectedUomSet={selectedUomSet}
    selectedTargetApplication={selectedTargetApplication}
    selectedGroupByFields={selectedGroupByFields}
    selectedExposureApplication={selectedExposureApplication}
    selectedExposureFactor={selectedExposureFactor}
    selectedExposurePercent={selectedExposurePercent}
    drillDown={drillDown}
    requestCustomWidth={requestCustomWidth}
    reflowHandle={reflowHandle}
  />;
}
